"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gsap = require("gsap");

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

var _all = require("animations-json/build/all");

var _LottieAnimationAPI2 = _interopRequireDefault(require("../LottieAnimationAPI"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function onDOMLoaded() {
  this.DOMLoaded = true;
  this.animation.removeEventListener('DOMLoaded', this.BindOnDOMLoaded);
  isReady(this);
}

function onLoadedImages() {
  this.imagesLoaded = true;
  this.animation.removeEventListener('loaded_images', this.BindOnLoadedImages);
  isReady(this);
}

function isReady(_self) {
  if (_self.DOMLoaded && _self.imagesLoaded) {
    _self.ready = true;

    _self.animation.trigger('ready');

    if (typeof _self.afterReady === 'function') {
      _self.afterReady();
    }
  }
}

function getCssStyle(placement, targetSize, videoScale) {
  var scale = placement.scale,
      opacity = placement.opacity,
      saturation = placement.saturation;
  var width = targetSize.w * scale;
  var height = targetSize.h * scale;
  var _placement$position = placement.position,
      x = _placement$position.x,
      y = _placement$position.y;
  return {
    position: 'absolute',
    width: width * videoScale,
    height: height * videoScale,
    left: x * videoScale,
    top: y * videoScale,
    opacity: opacity,
    filter: "grayscale(".concat(1 - saturation, ")")
  };
}

var WatermarkImage = /*#__PURE__*/function (_LottieAnimationAPI) {
  _inherits(WatermarkImage, _LottieAnimationAPI);

  var _super = _createSuper(WatermarkImage);

  function WatermarkImage(_ref) {
    var _this;

    var data = _ref.data,
        videoScale = _ref.videoScale;

    _classCallCheck(this, WatermarkImage);

    _this = _super.call(this);
    var crop = data.watermark.crop;
    _this.targetSize = crop.targetSize;
    _this.inDuration = 400;
    _this.intermissionDuration = 3000;
    _this.outDuration = 400;
    _this.totalDuration = 3800;
    _this.videoScale = videoScale || 1;
    var _crop$targetSize = crop.targetSize,
        w = _crop$targetSize.w,
        h = _crop$targetSize.h;
    var animation = (0, _all.getAnimationJson)('watermark'); // update svg size to target size

    animation.w = w;
    animation.h = h; // update image size and url

    var imageAssets = animation.assets[0];
    imageAssets.u = '';
    imageAssets.w = w;
    imageAssets.h = h;
    imageAssets.p = crop.url;

    if (data.placement) {
      _this.placement = data.placement;
    }

    _this.json = animation;
    return _this;
  }
  /**
   * _loadAnimation() load lottie animation (private function)
   * load the lottie animation update animation data with size and fonts before load
   * set animation position and size if animation include style object
   */


  _createClass(WatermarkImage, [{
    key: "_loadAnimation",
    value: function _loadAnimation(data, container) {
      this.container = container;
      var style = {};

      if (this.placement) {
        style = getCssStyle(this.placement, this.targetSize, this.videoScale);
      }

      this.innerContainer = document.createElement('span');

      _gsap.TweenMax.set(this.innerContainer, style);

      this.container.appendChild(this.innerContainer);
      this.animation = _lottieWeb.default.loadAnimation({
        container: this.innerContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: data
      }); // wait for image to be load than trigger custom ready event

      this.BindOnLoadedImages = onLoadedImages.bind(this);
      this.animation.addEventListener('loaded_images', this.BindOnLoadedImages);
      this.BindOnDOMLoaded = onDOMLoaded.bind(this);
      this.animation.addEventListener('DOMLoaded', this.BindOnDOMLoaded);
    }
  }, {
    key: "prepareAssets",
    value: function prepareAssets() {
      window.console.log('WATERMARK - prepareAssets');
      var assetPromises = this.json.assets.filter(function (asset) {
        return asset.id.indexOf('image') !== -1;
      }).filter(function (asset) {
        return asset.p.substring(0, 5) !== 'data:';
      }).map(function (asset) {
        return (0, _utils.toDataURL)(asset.p).then(function (b64) {
          asset.p = b64;
        });
      });
      return Promise.all(_toConsumableArray(assetPromises));
    }
  }, {
    key: "updateVideoScale",
    value: function updateVideoScale(scale) {
      this.videoScale = scale || 1;
      var style = getCssStyle(this.placement, this.targetSize, this.videoScale);

      _gsap.TweenMax.set(this.innerContainer, style);
    }
  }]);

  return WatermarkImage;
}(_LottieAnimationAPI2.default);

exports.default = WatermarkImage;